import React from 'react';
import TokenIcon from './TokenIcon';
import './ElixirAmount.css';

/**
 * ElixirAmount — canonical compact bolt+number elixir readout.
 * Matches the daily-quest chip bounty pill: 10px bolt, 9.5px/700
 * green tabular-num text, natural inline spacing. Use this anywhere
 * you need to show an elixir value as a compact green receipt.
 */
export default function ElixirAmount({ value, iconSize = 10, className = '', ...rest }) {
  return (
    <span className={`elixir-amount ${className}`.trim()} {...rest}>
      <TokenIcon size={iconSize} />
      {value}
    </span>
  );
}
